module.exports = __webpack_public_path__ + "img/usa.8339d5d8.jpg";